import PropTypes from 'prop-types'
import React from 'react'
import useTaskCitizen from '../../../hooks/useTaskCitizen'
import { serialize } from 'object-to-formdata'
import TaskExecutionsForm from '../procedures/TaskExecutionsForm'
import useTaskExecutionCitizen from '../../../hooks/useTaskExecutionCitizen'

const ProcedureTaskExecutionsForm = ({ procedureCode, taskId, token, onAfterSave: afterSave }) => {
  const { createTaskExecution } = useTaskExecutionCitizen(procedureCode)
  const handleSubmit = async values => {
    const formData = serialize({ ...values, task_id: taskId, token }, { indices: true })
    await createTaskExecution(formData, { onSuccess: afterSave })
  }
  const { data: task, status } = useTaskCitizen(procedureCode, token, taskId)
  if (status !== 'success') return null
  return <TaskExecutionsForm form={task.form} onSubmit={handleSubmit} kind={task.kind} />
}
export default ProcedureTaskExecutionsForm

ProcedureTaskExecutionsForm.propTypes = {
  onAfterSave: PropTypes.func.isRequired,
  procedureCode: PropTypes.string,
  taskId: PropTypes.number,
  token: PropTypes.string
}
